import { useEffect, useSyncExternalStore } from "react";
import { identitySnapshot, loadIdentity, subscribeIdentity } from "./identityClient";

export function useIdentity() {
  const state = useSyncExternalStore(subscribeIdentity, identitySnapshot);
  useEffect(() => {
    if (state.session && !state.profile && !state.loading && !state.error)
      void loadIdentity().catch(() => {});
  }, [state.session, state.profile, state.loading, state.error]);
  return state;
}
export function useSignedInIdentity() {
  const state = useIdentity();
  const name = state.profile?.name || state.session?.user.name || "Academy account";
  const initials = name
    .split(/\s+/)
    .filter(Boolean)
    .slice(0, 2)
    .map(part => part[0]?.toUpperCase())
    .join("");
  return {
    name,
    initials,
    email: state.session?.user.email || "",
    role: state.session?.roles.join(", ") || "",
    verified: state.security?.emailVerified ?? false,
  };
}
